import { Image } from 'components/Image/Image';
import './TransactionErrorViewRedesign.scss';

const TransactionErrorViewRedesign = props => {
  return (
    <div className="TransactionErrorViewRedesign format100 borderRadius8 grayShadow16 padTB20">
      <div className="flex-container justify-center">
        <Image imgClass="TransactionLoadingError" />
      </div>
      <div className="text-center fontGray300 text-16 m-text-14 padT8">
        {props.description}
      </div>
      <div
        className="text-center fontBlue100 text-16 m-text-14 padTB4 pointer"
        onClick={props.onRefreshClick}
      >
        Reload
      </div>
    </div>
  );
};

TransactionErrorViewRedesign.defaultProps = {
  description: 'There was an error loading transactions.',
};

export default TransactionErrorViewRedesign;
